"use client";

import { useState } from "react";

type PublicImageProps = {
  src: string;
  alt: string;
  fallbackTitle: string;
};

export function PublicImage({
  src,
  alt,
  fallbackTitle,
}: PublicImageProps) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div className="public-image public-image--fallback">
        <span>{fallbackTitle}</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className="public-image"
      onError={() => setFailed(true)}
    />
  );
}
